import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import { Card, Switch, Container, Button, TextField, Autocomplete, Tabs, Tab, Box, Stack, RadioGroup, FormControlLabel, Radio } from '@mui/material';
// import { Container, Button, Paper, Table, TableHead, TableBody, TableRow, TableCell, TableContainer,TextField,Stack } from '@mui/material';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import {Backdrop, CircularProgress, } from '@mui/material';
// import { pink100 } from 'material-ui/styles/colors';
function Subdealercreate() {
    const [tabValue, setTabValue] = useState("Personal Details");
    // const [tabvalue1, settabvalue1] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [Enquiry, setEnquiry] = useState(null);
    const [selectedSubdealer, setSelectedSubdealer] = useState(null);
    const [selectedRetailer, setSelectedRetailer] = useState(null);
    const [showquery, setShowquery] = useState(false);
    const [showpersonal, setShowpersonal] = useState(true);
    const [showArea, setShowArea] = useState(false);
    const [showsegment, setShowsegment] = useState(false);
    const [showgeneral, setShowgeneral] = useState(false);
    const [showbtn, setShowbtn] = useState(true);
    const [showexisting, setshowexisting] = useState(false);
    const [selectedDate, setSelectedDate] = useState();
    // const [selectedDate, setSelectedDate] = useState(dayjs());
    const [PersonalDetails, setPersonalDetails] = useState('');
    const [shopName, setShopName] = useState('');
    const [ShopAddress, setShopAddress] = useState('');
    const [ShopIncharge, setShopIncharge] = useState('');
    const [shopmobile, setshopmobile] = useState('');
    const [shopphone, setshopphone] = useState('');
    const [shopemail, setshopemail] = useState('');
    const [shopsize, setshopsize] = useState('');
    const [shopgst, setshopgst] = useState('');
    const [btnvalue, setbtnvalue] = useState(0);
    const [gender, setGender] = useState(null);

    const [country, setcountry] = useState([]);
    const [state, setstate] = useState([]);
    const [district, setdistrict] = useState([]);
    const [city, setcity] = useState([]);
    const [area, setarea] = useState([]);
    const [pincode, setpincode] = useState([]);
    const [subdealers, setsubdealers] = useState([]);
    const [subdealerdetail, setsubdealerdetail] = useState();

    const defaultValue = { label: 'Retailer', value: 'Retailer' };
    const [checked, setChecked] = useState(false);

  //  const [stateCodeToLabelMap, setStateCodeToLabelMap] = useState({});

    // const [selectedCountry, setSelectedCountry] = useState(county_list.length > 0 ? county_list[0] : null);
//    const [selectedCountry, setSelectedCountry] = useState(null);

//     const [selecteddistrict, setSelecteddistrict] = useState(null);
//     const [selectedcity, setSelectedcity] = useState(null);
   // const [selectedarea, setSelectedarea] = useState(null);
    //const [selectedpincode, setSelectedpincode] = useState(null);

    const [isActiveA, setIsActiveA] = useState(false);
    const [displayTextA, setDisplayTextA] = useState('Inactive');
    const [displayValueA, setDisplayValueA] = useState('0');

    const [isActiveH, setIsActiveH] = useState(false);
    const [displayTextH, setDisplayTextH] = useState('Inactive');
    const [displayValueH, setDisplayValueH] = useState('0');

    const [isActiveT, setIsActiveT] = useState(false);
    const [displayTextT, setDisplayTextT] = useState('Inactive');
    const [displayValueT, setDisplayValueT] = useState('0');

    const [isActiveS, setIsActiveS] = useState(false);
    const [displayTextS, setDisplayTextS] = useState('Inactive');
    const [displayValueS, setDisplayValueS] = useState('0');

    const [isActiveP, setIsActiveP] = useState(false);
    const [displayTextP, setDisplayTextP] = useState('Inactive');
    const [displayValueP, setDisplayValueP] = useState('0');

    const [isActiveW, setIsActiveW] = useState(false);
    const [displayTextW, setDisplayTextW] = useState('Inactive');
    const [displayValueW, setDisplayValueW] = useState('0');

    const [isActiveU, setIsActiveU] = useState(false);
    const [displayTextU, setDisplayTextU] = useState('Inactive');
    const [displayValueU, setDisplayValueU] = useState('0');

    const [isActiveQ, setIsActiveQ] = useState(false);
    const [displayTextQ, setDisplayTextQ] = useState('Inactive');
    const [displayValueQ, setDisplayValueQ] = useState('0');

    const [isActiveX, setIsActiveX] = useState(false);
    const [displayTextX, setDisplayTextX] = useState('Inactive');
    const [displayValueX, setDisplayValueX] = useState('0');

   // const [selectedstate, setSelectedstate] = useState(null);
    const [selectednameboardDate, setselectednameboardDate] = useState(null);
    const [selectedlastvistedDate, setselectedlastvistedDate] = useState(null);
    const [selectedissuedDate, setselectedissuedDate] = useState(null);
    const [selectedvalidDate, setselectedvalidDate] = useState(null);
    const [selectedplannedDate, setselectedplannedDate] = useState('');
    const [selectedcompletedDate, setselectedcompletedDate] = useState('');

    // const login_id = localStorage.getItem("LOGIN_ID");
    //const BRANCH_CODE = "1625";
    
    //const login_id = "USz1Po\/Amao+QpIajNL8wpl88fYYDxEeoA5LAwaBpFteaCPh4a1aQi\/3QKB4xP8NpmHjWqqk+VeF2cKyXSl+LQ==";
    const login_id = localStorage.getItem("LOGIN_ID");
    const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
   
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [loading, setloading] = React.useState(false);
// useEffect(() => {
//     if (country && country.length > 0) {
//         setSelectedCountry({
//             Value: country[0].CODE,
//             Label: country[0].DESCRIPTION
//         });
//     }
// }, [country]);

// Initialize selectedstate with the first item in state_list
const [selectedstate, setSelectedstate] = useState(null);
const [selectestatecode, setselectestatecode] = useState(null);
const [selectedistrictcode, setselectedistrictcode] = useState(null);
const [selectecitycode, setselectecitycode] = useState(null);
const [selecteareacode, setselecteareacode] = useState(null);
const [selectepincode, setselectepincode] = useState(null);

// useEffect(() => {
//     if (state.length > 0) {
//         const map = buildStateCodeToLabelMap(state);
//         setStateCodeToLabelMap(map);
//     }
// }, [state]);

// useEffect(() => {
//     if (state && state.length > 0) {
//         const map = buildStateCodeToLabelMap(state);
//         setStateCodeToLabelMap(map);
//     }
// }, [state]);

// useEffect(() => {
//     if (state && state.length > 0) {
//         setSelectedstate({
//             Value: state[0].CODE,
//             Label: state[0].DESCRIPTION
//         });
//     }
// }, [state]);

// Initialize selecteddistrict with the first item in district_list
const [selecteddistrict, setSelecteddistrict] = useState(null);

// useEffect(() => {
//     if (district && district.length > 0) {
//         setSelecteddistrict({
//             Value: district[0].CODE,
//             Label: district[0].DESCRIPTION
//         });
//     }
// }, [district]);

// Initialize selectedcity with the first item in city_list
const [selectedcity, setSelectedcity] = useState(null);

// useEffect(() => {
//     if (city && city.length > 0) {
//         setSelectedcity({
//             Value: city[0].CODE,
//             Label: city[0].DESCRIPTION
//         });
//     }
// }, [city]);

const [selectedarea, setSelectedarea] = useState(null);

// useEffect(() => {
//     if (area && area.length > 0) {
//         setSelectedarea({
//             Value: area[0].CODE,
//             Label: area[0].DESCRIPTION
//         });
//     }
// }, [area]);

const [selectedpincode, setSelectedpincode] = useState(null);

// useEffect(() => {
//     if (pincode && pincode.length > 0) {
//         setSelectedpincode({
//             Value: pincode[0].CODE,
//             Label: pincode[0].DESCRIPTION
//         });
//     }
// }, [pincode]);

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    const handlenameboardDateChange = (newDate) => {
        setselectednameboardDate(newDate);
    };
    const handleissuedDateChange = (newDate) => {
        setselectedissuedDate(newDate);
    }; const handlevalidDateChange = (newDate) => {
        setselectedvalidDate(newDate);
    };
  

const handleplannedDateChange = (newValue) => {
   
    setselectedplannedDate(newValue);
};

    const handlecompletedDateChange = (newValue) => {
        setselectedcompletedDate(newValue);
    };

    const handlelastvistedChange = (newDate) => {
        setselectedlastvistedDate(newDate);
    };

    const [valueA, setvalueA] = useState(0)
    const [valueH, setvalueH] = useState(0)
    const [valueT, setvalueT] = useState(0)
    const [valueS, setvalueS] = useState(0)
    const [valueP, setvalueP] = useState(0)
    const [valueW, setvalueW] = useState(0)
    const [valueU, setvalueU] = useState(0)
    const [valueQ, setvalueQ] = useState(0)
    const [valueX, setvalueX] = useState(0)

    const [active, setActive] = useState('1');
    const handleActiveChange = (event) => {
        setActive(event.target.value); // Update the active state with the selected radio button's value
    };
    const handleToggleA = () => {
        setIsActiveA(!isActiveA);
        if (!isActiveA) {
            setDisplayTextA('Active');
            setDisplayValueA('1');
            setvalueA(1)
        } else {
            setDisplayTextA('Inactive');
            setDisplayValueA('0');
            setvalueA(0)
        }

    };
    const handleToggleH = () => {
        setIsActiveH(!isActiveH);
        if (!isActiveH) {
            setDisplayTextH('Active');
            setDisplayValueH('1');
            setvalueH(1)
        } else {
            setDisplayTextH('Inactive');
            setDisplayValueH('0');
            setvalueH(0)
        }
    };
    const handleToggleT = () => {
        setIsActiveT(!isActiveT);
        if (!isActiveT) {
            setDisplayTextT('Active');
            setDisplayValueT('1');
            setvalueT(1)
        } else {
            setDisplayTextT('Inactive');
            setDisplayValueT('0');
            setvalueT(0)
        }
    };

    const handleToggleS = () => {
        setIsActiveS(!isActiveS);
        if (!isActiveS) {
            setDisplayTextS('Active');
            setDisplayValueS('1');
            setvalueS(1)
        } else {
            setDisplayTextS('Inactive');
            setDisplayValueS('0');
            setvalueS(0)
        }
    };
    const handleToggleP = () => {
        setIsActiveP(!isActiveP);
        if (!isActiveP) {
            setDisplayTextP('Active');
            setDisplayValueP('1');
            setvalueP(1)
        } else {
            setDisplayTextP('Inactive');
            setDisplayValueP('0');
            setvalueP(0)
        }


    };
    const handleToggleW = () => {
        setIsActiveW(!isActiveW);
        if (!isActiveW) {
            setDisplayTextW('Active');
            setDisplayValueW('1');
            setvalueW(1)
        } else {
            setDisplayTextW('Inactive');
            setDisplayValueW('0');
            setvalueW(0)
        }
    };
    const handleToggleU = () => {
        setIsActiveU(!isActiveU);
        if (!isActiveU) {
            setDisplayTextU('Active');
            setDisplayValueU('1');
            setvalueU(1)
        } else {
            setDisplayTextU('Inactive');
            setDisplayValueU('0');
            setvalueU(0)
        }


    };
    const handleToggleQ = () => {
        setIsActiveQ(!isActiveQ);
        if (!isActiveQ) {
            setDisplayTextQ('Active');
            setDisplayValueQ('1');
            setvalueQ(1)
        } else {
            setDisplayTextQ('Inactive');
            setDisplayValueQ('0');
            setvalueQ(0)
        }
    };
    const handleToggleX = () => {
        setIsActiveX(!isActiveX);
        if (!isActiveX) {
            setDisplayTextX('Active');
            setDisplayValueX('1');
            setvalueX(1)
        } else {
            setDisplayTextX('Inactive');
            setDisplayValueX('0');
            setvalueX(0)
        }
    };


    const handleSwitchChange = (checked) => {
        setChecked(checked);
    };


    const options = [
        { label: 'New', value: 'New' },
        { label: 'Existing', value: 'Existing' }
    ];


    const Subdealer = [
        { label: 'Subdealer Code 1', value: 'SubdealerCode1' },
        { label: 'Subdealer Code 2', value: 'SubdealerCode2' }
    ];
    const Retailer = [
        { label: 'Retailer', value: 'Retailer' }

    ];
    const handleGenderChange = (event, newValue) => {
        setGender(newValue); // Update gender state with the selected option
    };

    const handleShopAddressChange = (event) => {

        const inputValue = event.target.value;
        setShopAddress(inputValue);

    };
    const handleShopInchargeChange = (event) => {

        const inputValue = event.target.value;
        setShopIncharge(inputValue);

    };
    const handleshopmobileChange = (event) => {

        const inputValue = event.target.value;
        setshopmobile(inputValue);

    };

    const handleshopphoneChange = (event) => {

        const inputValue = event.target.value;
        setshopphone(inputValue);

    };
    const handleshopemailChange = (event) => {

        const inputValue = event.target.value;
        setshopemail(inputValue);

    };
    const handleshopsizeChange = (event) => {

        const inputValue = event.target.value;
        setshopsize(inputValue);

    };


    const handleshopgstChange = (event) => {

        const inputValue = event.target.value;
        setshopgst(inputValue);

    };



    const buildStateCodeToLabelMap = (stateData) => {
        const map = {};
        stateData.forEach(state => {
            map[state.CODE] = state.DESCRIPTION;
        });
        return map;
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/getcountry');
                if (response.status === 200) {
                    setcountry(response.data.getcountry);
                } else {
                    console.error('Failed to fetch country data');
                    Swal.fire({
                        icon: 'error',
                        text: 'Failed to fetch country data. Please try again.'
                    });
                }
            } catch (error) {
                console.error('Error fetching country data:', error);
                Swal.fire({
                    icon: 'error',
                    text: `Error: ${error.message}`
                });
            }
        };
    
        fetchData();
    }, []);

    const handleEnquiryChange = (event, newValue) => {
        setSelectedEnquiry(newValue);
    }
    const handleRetailerChange = (event, newValue) => {
        setSelectedRetailer(newValue);
    }

    const [selectedCountryCode, setSelectedCountryCode] = useState('');

    // Label mapping objects
    const [countryCodeToLabelMap, setCountryCodeToLabelMap] = useState({});
    const [stateCodeToLabelMap, setStateCodeToLabelMap] = useState({});
    const [districtCodeToLabelMap, setDistrictCodeToLabelMap] = useState({});
    const [cityCodeToLabelMap, setCityCodeToLabelMap] = useState({});
    const [areaCodeToLabelMap, setAreaCodeToLabelMap] = useState({});
    const [pincodeCodeToLabelMap, setPincodeCodeToLabelMap] = useState({});

    // Function to fetch country data
    const fetchCountryData = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/getcountry`);
            if (response.status === 200) {
                setcountry(response.data.getcountry);
                const codeToLabelMap = {};
                response.data.getcountry.forEach(country => {
                    codeToLabelMap[country.CODE] = country.DESCRIPTION;
                });
                setCountryCodeToLabelMap(codeToLabelMap);
            } else {
                console.error('Failed to fetch country data');
            }
        } catch (error) {
           // alert('country');
            console.error('Error fetching country data:', error);
            // Swal.fire({
            //     icon: "info",
            //     text: `Error1: ${error.message}`
            // });
        }
    };


    const handleCountryChange = (event, value) => {
        setSelectedCountry(value);
        //fetchStates(value);
    };

    // const fetchStates = async (selectedCountry) => {
    //    // alert('1');
    //     if (selectedCountry) {
    //         try {
    //            // alert('2');
    //             const response = await axios.post(BASE_URL + '/getstate', { county: selectedCountry.Value });
    //             if (response.status === 200) {
    //               //  alert('3');
    //                 setstate(response.data.getstate);
    //                // alert('4');
    //                 const codeToLabelMap = {};
    //                 response.data.getstate.forEach(state => {
    //                     codeToLabelMap[state.CODE] = state.DESCRIPTION;
    //                 });
    //                 setStateCodeToLabelMap(codeToLabelMap);

    //             } else {
    //                 alert('else');
    //                 console.error('Failed to fetch states');
    //                 Swal.fire({
    //                     icon: 'error',
    //                     text: 'Failed to fetch states. Please try again.'
    //                 });
    //             }
    //         } catch (error) {
    //             alert('err');
    //             console.error('Error fetching states:', error);
    //             Swal.fire({
    //                 icon: 'error',
    //                 text: `Error2: ${error.message}`
    //             });
    //         }
    //     }
    // };
    // Function to fetch state data based on selected country
    useEffect(() => {
       // alert('1');
        const fetchData = async () => {
            if (selectedCountry) {
            //    alert('2');
                try {
                    const response = await axios.post(`${BASE_URL}/getstate`, { county: selectedCountry.Value });
                  //  alert('3');
                    if (response.status === 200) {
                    //    alert('4');
                        setstate(response.data.getstate);
                    //    alert('5');
                        const codeToLabelMap = {};
                        response.data.getstate.forEach(state => {
                            codeToLabelMap[state.CODE] = state.DESCRIPTION;
                        });
                        setStateCodeToLabelMap(codeToLabelMap);
                    } else {
                        console.error('Failed to fetch state data');
                    }
                } catch (error) {
                   // alert('state');
                    console.error('Error fetching state data:', error);
                    // Swal.fire({
                    //     icon: "info",
                    //     text: `Error3: ${error.message}`
                    // });
                }
            }
        };

        fetchData();
    }, [selectedCountry]);
    useEffect(() => {
       
        const matchestate = state_list.find(
            (state) => state.Value === selectestatecode
        );
        setSelectedstate(matchestate || null);
     
    }, [state,selectestatecode]);
    useEffect(() => {
      
        const matchdistrict = district_list.find(
            (district) => district.Value === selectedistrictcode
        );
        setSelecteddistrict(matchdistrict || null);
      
    }, [district,selectedistrictcode]);
    useEffect(() => {
    
        const matchcity = city_list.find(
            (city) => city.Value === selectecitycode
        );
        setSelectedcity(matchcity || null);
    
    }, [city,selectecitycode]);
    useEffect(() => {
     
        const matcharea = area_list.find(
            (area) => area.Value === selecteareacode
        );
        setSelectedarea(matcharea || null);
      
    }, [area,selecteareacode]);
    useEffect(() => {
       
        const matchpin = pincode_list.find(
            (pin) => pin.Value === selectepincode
        );
        setSelectedpincode(matchpin || null);
      
    }, [pincode,selectepincode]);

    // Function to fetch district data based on selected country and state
    useEffect(() => {
        const fetchData = async () => {
            if (selectedCountry && selectedstate) {
                try {
                    const response = await axios.post(`${BASE_URL}/getdistrict`, {
                        county: selectedCountry.Value,
                        region: selectedstate.Value
                    });
                    if (response.status === 200) {
                        setdistrict(response.data.getdistrict);
                        const codeToLabelMap = {};
                        response.data.getdistrict.forEach(district => {
                            codeToLabelMap[district.CODE] = district.DESCRIPTION;
                        });
                        setDistrictCodeToLabelMap(codeToLabelMap);
                    } else {
                        console.error('Failed to fetch district data');
                    }
                } catch (error) {
                    //alert('district');
                    console.error('Error fetching district data:', error);
                    // Swal.fire({
                    //     icon: "info",
                    //     text: `Error4: ${error.message}`
                    // });
                }
            }
        };

        fetchData();
    }, [selectedCountry, selectedstate]);

    // Function to fetch city data based on selected country, state, and district
    useEffect(() => {
        const fetchData = async () => {
            if (selectedCountry && selectedstate && selecteddistrict) {
                try {
                    const response = await axios.post(`${BASE_URL}/getcity`, {
                        county: selectedCountry.Value,
                        region: selectedstate.Value,
                        district: selecteddistrict.Value
                    });
                    if (response.status === 200) {
                        setcity(response.data.getcity);
                        const codeToLabelMap = {};
                        response.data.getcity.forEach(city => {
                            codeToLabelMap[city.CODE] = city.DESCRIPTION;
                        });
                        setCityCodeToLabelMap(codeToLabelMap);
                    } else {
                        console.error('Failed to fetch city data');
                    }
                } catch (error) {
                   // alert('city');
                    console.error('Error fetching city data:', error);
                    // Swal.fire({
                    //     icon: "info",
                    //     text: `Error5: ${error.message}`
                    // });
                }
            }
        };

        fetchData();
    }, [selectedCountry, selectedstate, selecteddistrict]);

    // Function to fetch area data based on selected country, state, district, and city
    useEffect(() => {
        const fetchData = async () => {
            if (selectedCountry && selectedstate && selecteddistrict && selectedcity) {
                try {
                    const response = await axios.post(`${BASE_URL}/getarea`, {
                        county: selectedCountry.Value,
                        region: selectedstate.Value,
                        district: selecteddistrict.Value,
                        city: selectedcity.Value
                    });
                    if (response.status === 200) {
                        setarea(response.data.getarea);
                        const codeToLabelMap = {};
                        response.data.getarea.forEach(area => {
                            codeToLabelMap[area.CODE] = area.DESCRIPTION;
                        });
                        setAreaCodeToLabelMap(codeToLabelMap);
                    } else {
                        console.error('Failed to fetch area data');
                    }
                } catch (error) {
                  //  alert('area');
                    console.error('Error fetching area data:', error);
                    // Swal.fire({
                    //     icon: "info",
                    //     text: `Error6: ${error.message}`
                    // });
                }
            }
        };

        fetchData();
    }, [selectedCountry, selectedstate, selecteddistrict, selectedcity]);

    // Function to fetch pincode data based on selected country, state, district, city, and area
    useEffect(() => {
        const fetchData = async () => {
            if (selectedCountry && selectedstate && selecteddistrict && selectedcity && selectedarea) {
                try {
                    const response = await axios.post(`${BASE_URL}/getpincodes`, {
                        county: selectedCountry.Value,
                        region: selectedstate.Value,
                        district: selecteddistrict.Value,
                        city: selectedcity.Value,
                        area: selectedarea.Value
                    });
                    if (response.status === 200) {
                        setpincode(response.data.getpincode);
                        const codeToLabelMap = {};
                        response.data.getpincode.forEach(pincode => {
                            codeToLabelMap[pincode.CODE] = pincode.DESCRIPTION;
                        });
                        setPincodeCodeToLabelMap(codeToLabelMap);
                    } else {
                        console.error('Failed to fetch pincode data');
                    }
                } catch (error) {
                   // alert('errp');
                    console.error('Error fetching pincode data:', error);
                    // Swal.fire({
                    //     icon: "info",
                    //     text: `Error: ${error.message}`
                    // });
                }
            }
        };

        fetchData();
    }, [selectedCountry, selectedstate, selecteddistrict, selectedcity, selectedarea]);

    
    //const countryCodeToLabelMap = {};
    country.forEach(country => {
        countryCodeToLabelMap[country.CODE] = country.DESCRIPTION;
    });
    const genderOptions = [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" }
    ];
    const handleSubdealerChange = async (event, newValue) => {
        setloading(true);
        setSelectedSubdealer(newValue);
    
        try {
            const response = await axios.post(BASE_URL + '/getsubdealerdetails', { subdealercode: newValue.Value });
    
            if (response.status === 200) {
                setloading(false);
                const subdealerDetails = response.data.getsubdealerdetails[0];
    
                setShopName(subdealerDetails.subdealername);
                setShopAddress(subdealerDetails.communicationaddress);
                setShopIncharge(subdealerDetails.nameofincharge);
                setSelectedstate(subdealerDetails.dob);
                setshopphone(subdealerDetails.phoneno);
                setshopmobile(subdealerDetails.mobileno);
                setshopemail(subdealerDetails.emailid);
                setshopsize(subdealerDetails.sizeoftheshop);
                setshopgst(subdealerDetails.GSTNO);
                setActive(subdealerDetails.active);
    
                const selectedGender = genderOptions.find(option => option.value === subdealerDetails.gender);
                
                setGender(selectedGender || null);
                const dobss = dayjs(subdealerDetails.dob);
                setSelectedDate(dobss);
                const nameboardDate = dayjs(subdealerDetails.nameboardprovidedon);
                setselectednameboardDate(nameboardDate);
                const dealership_issuedon = dayjs(subdealerDetails.dealership_issuedon);
                setselectedissuedDate(dealership_issuedon);
                const dealership_validupto = dayjs(subdealerDetails.dealership_validupto);
                setselectedvalidDate(dealership_validupto);
                const exelastvisitedon = dayjs(subdealerDetails.exelastvisitedon);
                setselectedlastvistedDate(exelastvisitedon);
                const support_planned =subdealerDetails.support_planned;
                setselectedplannedDate(support_planned);
                const support_provided = subdealerDetails.support_provided;
                setselectedcompletedDate(support_provided);
    
                // Fetch labels for all codes
                
                setSelectedstate()
            // Fetch labels for all codes
            const selectedCountryLabel = countryCodeToLabelMap[subdealerDetails.country_code] || '';
            const selectedStateLabel = stateCodeToLabelMap[subdealerDetails.state_code] || '';
            const selectedDistrictLabel = districtCodeToLabelMap[subdealerDetails.district_code] || '';
            const selectedCityLabel = cityCodeToLabelMap[subdealerDetails.city_code] || '';
            const selectedAreaLabel = areaCodeToLabelMap[subdealerDetails.area_code] || '';
            const selectedPincodeLabel = pincodeCodeToLabelMap[subdealerDetails.pincode] || '';


            //segments 
           
          
            if (subdealerDetails.A === '1') {
                setDisplayTextA('Active');
                setDisplayValueA('1');
                setvalueA(1);
                setIsActiveA(1);
               // alert(valueA);
               
            } else {
                setDisplayTextA('Inactive');
                setDisplayValueA('0');
                setvalueA(0);
                setIsActiveA(0);
            }
            if (subdealerDetails.H === '1') {
                setDisplayTextH('Active');
                setDisplayValueH('1');
                setvalueH(1);
                setIsActiveH(1);
               // alert(valueA);
               
            } else {
                setDisplayTextH('Inactive');
                setDisplayValueH('0');
                setvalueH(0);
                setIsActiveH(0);
            }
            if (subdealerDetails.T === '1') {
                setDisplayTextT('Active');
                setDisplayValueT('1');
                setvalueT(1);
                setIsActiveT(1);
               // alert(valueA);
               
            } else {
                setDisplayTextT('Inactive');
                setDisplayValueT('0');
                setvalueT(0);
                setIsActiveT(0);
            }
            if (subdealerDetails.S === '1') {
                setDisplayTextS('Active');
                setDisplayValueS('1');
                setvalueS(1);
                setIsActiveS(1);
               // alert(valueA);
               
            } else {
                setDisplayTextS('Inactive');
                setDisplayValueS('0');
                setvalueS(0);
                setIsActiveS(0);
            }
            if (subdealerDetails.P === '1') {
                setDisplayTextP('Active');
                setDisplayValueP('1');
                setvalueP(1);
                setIsActiveP(1);
               // alert(valueA);
               
            } else {
                setDisplayTextP('Inactive');
                setDisplayValueP('0');
                setvalueP(0);
                setIsActiveP(0);
            }
            if (subdealerDetails.W === '1') {
                setDisplayTextW('Active');
                setDisplayValueW('1');
                setvalueW(1);
                setIsActiveW(1);
               // alert(valueA);
               
            } else {
                setDisplayTextW('Inactive');
                setDisplayValueW('0');
                setvalueW(0);
                setIsActiveW(0);
            }
            if (subdealerDetails.U === '1') {
                setDisplayTextU('Active');
                setDisplayValueU('1');
                setvalueU(1);
                setIsActiveU(1);
               // alert(valueA);
               
            } else {
                setDisplayTextU('Inactive');
                setDisplayValueU('0');
                setvalueU(0);
                setIsActiveU(0);
            }
            if (subdealerDetails.Q === '1') {
                setDisplayTextQ('Active');
                setDisplayValueQ('1');
                setvalueQ(1);
                setIsActiveQ(1);
               // alert(valueA);
               
            } else {
                setDisplayTextQ('Inactive');
                setDisplayValueQ('0');
                setvalueQ(0);
                setIsActiveQ(0);
            }
            if (subdealerDetails.X === '1') {
                setDisplayTextX('Active');
                setDisplayValueX('1');
                setvalueX(1);
                setIsActiveX(1);
               // alert(valueA);
               
            } else {
                setDisplayTextX('Inactive');
                setDisplayValueX('0');
                setvalueX(0);
                setIsActiveX(0);
            }
            //alert(valueA);
           // console.log('subdelersales',subdealerDetails);
// alert('0');
            // Set selected states based on subdealerDetails
            setSelectedCountry({
                Value: subdealerDetails.country_code,
                Label: selectedCountryLabel
            });
           // alert('01');
            setSelectedstate({
                Value: subdealerDetails.state_code,
                Label: selectedStateLabel
            });
            setselectestatecode(subdealerDetails.state_code);
            setSelecteddistrict({
                Value: subdealerDetails.district_code,
                Label: selectedDistrictLabel
            });
  setselectedistrictcode(subdealerDetails.district_code);
          
            setSelectedcity({
                Value: subdealerDetails.city_code,
                Label: selectedCityLabel
            });
            setselectecitycode(subdealerDetails.city_code);
       
            setSelectedarea({
                Value: subdealerDetails.area_code,
                Label: selectedAreaLabel
            });
            setselecteareacode(subdealerDetails.area_code);
          
            setSelectedpincode({
                Value: subdealerDetails.pincode,
                Label: selectedPincodeLabel
            });
            
            setselectepincode(subdealerDetails.pincode);
             // const selectedCountryLabel = countryCodeToLabelMap[subdealerDetails.country_code] || '';
            // const selectedStateLabel = stateCodeToLabelMap[subdealerDetails.state_code] || '';
            // const selectedDistrictLabel = districtCodeToLabelMap[subdealerDetails.district_code] || '';
            // const selectedCityLabel = cityCodeToLabelMap[subdealerDetails.city_code] || '';
            // const selectedAreaLabel = areaCodeToLabelMap[subdealerDetails.area_code] || '';
            // const selectedPincodeLabel = pincodeCodeToLabelMap[subdealerDetails.pincode] || '';

           
                // No need to handle async calls for dropdowns that are not in select format
            } else {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Unexpected response status from another API.'
                });
            }
        } catch (error) {
            setloading(false);
            if (error.response) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'No response received from the server. Please try again later.'
                });
            } else {
                setloading(false);
                console.error('Error:', error.message);
            }
        }
    };
    


    const handleProcessChange = async (event, newValue) => {
        setSelectedOption(newValue);

        if (newValue.value === "New") {
            clearFields();
            setShowquery(true);
            setShowbtn(false);
            setshowexisting(false);
            setbtnvalue(0);


            try {
                const response = await axios.post(BASE_URL + '/getenqiry', { county: newValue.Value });

                if (response.status === 200) {
                    setEnquiry(response.data.getenqiry);

                    // Optionally, handle response data here
                } else {
                    Swal.fire({
                        icon: "info",
                        text: 'Unexpected response status from another API.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "info",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "info",
                        text: 'No response received from the server. Please try again later.'
                    });
                } else {
                   
                }
                console.error('Error:', error.message);
            }



        } else {
            setShowbtn(false);
            setShowquery(false);
            setshowexisting(true);
            setbtnvalue(1);


            try {
                const response = await axios.post(BASE_URL + '/getsubdealerold', { login_id: login_id, branchcode: BRANCH_CODE });

                if (response.status === 200) {
                    clearFields();
                    setsubdealers(response.data.getsubdealerold);
                   
                    // Optionally, handle response data here
                } else {
                    Swal.fire({
                        icon: "info",
                        text: 'Unexpected response status from another API.'
                    });
                }
            } catch (error) {
                if (error.response) {
                    Swal.fire({
                        icon: "info",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "info",
                        text: 'No response received from the server. Please try again later.'
                    });
                } else {
                   
                }
                console.error('Error:', error.message);
            }

        }

    };

    const enquiry_list = Enquiry ? Enquiry.map((type) => ({
        Value: type.id,
        Label: type.name,
    })) : [];

    const subdealer_list = subdealers ? subdealers.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];
    const TabPanel = ({ children, value, index }) => (


        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
    const handleChange = (event, newValue) => {
        setTabValue(newValue);

        // alert(newValue);

        if (tabValue === 'Personal Details') {
            setShowpersonal(true);
            setShowArea(false);
            setShowsegment(false);
            setShowgeneral(false);
        }
        else if (tabValue === 'Area Details') {
            setShowpersonal(false);
            setShowArea(true);
            setShowsegment(false);
            setShowgeneral(false);
        }
        else if (tabValue === 'Segment Configuration') {
            setShowpersonal(false);
            setShowArea(false);
            setShowsegment(true);
            setShowgeneral(false);
        }
        else if (tabValue === 'General Details') {
            setShowpersonal(false);
            setShowArea(false);
            setShowsegment(false);
            setShowgeneral(true);
        }
        else {

        }
    };

    const handleShopNameChange = (event) => {

        const inputValue = event.target.value;
        setShopName(inputValue);

    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/getcountry', { login_id });
                if (response.status === 200) {
                    setcountry(response.data.getcountry);
                } else {
                    Swal.fire({
                        icon: "info",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: "info",
                    text: `Error: ${error.response.data.message}`
                });
            }
        };

        fetchData();
    }, [login_id]);

    // Convert country data into county_list
    const county_list = country ? country.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

    // Initialize selectedCountry with the first item in county_list
    //const [selectedCountry, setSelectedCountry] = useState(county_list.length > 0 ? county_list[0] : null);

    // Fetch state data based on selected country
    // useEffect(() => {
    //     if (selectedCountry) {
    //         const fetchData = async () => {
    //             try {
    //                 const response = await axios.post(BASE_URL + '/getstate', { county: selectedCountry.Value });

    //                 if (response.status === 200) {
    //                     setstate(response.data.getstate);
    //                 } else {
    //                     Swal.fire({
    //                         icon: "info",
    //                         text: 'Unexpected response status from another API.'
    //                     });
    //                 }
    //             } catch (error) {
    //                 Swal.fire({
    //                     icon: "info",
    //                     text: `Error: ${error.response.data.message}`
    //                 });
    //             }
    //         };

    //         fetchData();
    //     }
    // }, [selectedCountry,country]);

    // Convert state data into state_list
    const state_list = state ? state.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

    // Initialize selectedstate with the first item in state_list
   // const [selectedstate, setSelectedstate] = useState(state_list.length > 0 ? state_list[0] : null);

    // Fetch district data based on selected country and state
    // useEffect(() => {
    //     if (selectedCountry && selectedstate) {
    //         const fetchData = async () => {
    //             try {
    //                 const response = await axios.post(BASE_URL + '/getdistrict', {
    //                     county: selectedCountry.Value,
    //                     region: selectedstate.Value,
    //                 });

    //                 if (response.status === 200) {
    //                     setdistrict(response.data.getdistrict);
    //                 } else {
    //                     Swal.fire({
    //                         icon: "info",
    //                         text: 'Unexpected response status from another API.'
    //                     });
    //                 }
    //             } catch (error) {
    //                 Swal.fire({
    //                     icon: "info",
    //                     text: `Error: ${error.response.data.message}`
    //                 });
    //             }
    //         };

    //         fetchData();
    //     }
    // }, [selectedCountry, selectedstate]);

    // Convert district data into district_list
    const district_list = district ? district.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

    // Initialize selecteddistrict with the first item in district_list
    //const [selecteddistrict, setSelecteddistrict] = useState(district_list.length > 0 ? district_list[0] : null);

    // Fetch city data based on selected country, state, and district
//     useEffect(() => {
//         if (selectedCountry && selectedstate && selecteddistrict) {
//             const fetchData = async () => {
//                 try {
//                     const response = await axios.post(BASE_URL + '/getcity', {
//                         county: selectedCountry.Value,
//                         region: selectedstate.Value,
//                         district: selecteddistrict.Value,
//                     });

//                     if (response.status === 200) {
//                         setcity(response.data.getcity);
//                     } else {
//                         Swal.fire({
//                             icon: "info",
//                             text: 'Unexpected response status from another API.'
//                         });
//                     }
//                 } catch (error) {
//                     Swal.fire({
//                         icon: "info",
//                         text: `Error: ${error.response.data.message}`
//                     });
//                 }
//             };

//             fetchData();
//         }
//     }, [selectedCountry, selectedstate, selecteddistrict]);

//     // Convert city data into city_list
    const city_list = city ? city.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

//     // Initialize selectedcity with the first item in city_list
//     //const [selectedcity, setSelectedcity] = useState(city_list.length > 0 ? city_list[0] : null);




//     useEffect(() => {
//         if (selectedCountry && selectedstate && selecteddistrict && selectedcity) {
//             const fetchData = async () => {
//                 try {
//                     const response = await axios.post(BASE_URL + '/getarea', {
//                         county: selectedCountry.Value,
//                         region: selectedstate.Value,
//                         city: selectedcity.Value,
//                         district: selecteddistrict.Value,
//                     });
    
//                     if (response.status === 200) {
//                         setarea(response.data.getarea);
//                     } else {
//                         Swal.fire({
//                             icon: "info",
//                             text: 'Unexpected response status from another API.'
//                         });
//                     }
//                 } catch (error) {
//                     Swal.fire({
//                         icon: "info",
//                         text: `Error: ${error.response.data.message}`
//                     });
//                 }
//             };
    
//             fetchData();
//         }
//     }, [selectedCountry, selectedstate, selecteddistrict, selectedcity]);

    const area_list = area ? area.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];


//    useEffect(() => {
//     if (selectedCountry && selectedstate && selecteddistrict && selectedcity && selectedarea) {
//         const fetchData = async () => {
//             try {
//                 const response = await axios.post(BASE_URL + '/getpincodes', {
//                     county: selectedCountry.Value,
//                     region: selectedstate.Value,
//                     city: selectedcity.Value,
//                     district: selecteddistrict.Value,
//                     area: selectedarea.Value,
//                 });

//                 if (response.status === 200) {
//                     setpincode(response.data.getpincode);
//                 } else {
//                     Swal.fire({
//                         icon: "info",
//                         text: 'Unexpected response status from another API.'
//                     });
//                 }
//             } catch (error) {
//                 Swal.fire({
//                     icon: "info",
//                     text: `Error: ${error.response.data.message}`
//                 });
//             }
//         };

//         fetchData();
//     }
// }, [selectedCountry, selectedstate, selecteddistrict, selectedcity, selectedarea]);

    const pincode_list = pincode ? pincode.map((type) => ({
        Value: type.CODE,
        Label: type.DESCRIPTION,
    })) : [];

    const handlepincodeChange = (event, newValue) => {
        setSelectedpincode(newValue);
    };

    const formatDateToDDMMYYYY = (isoString) => {
        if (!isoString) return "";
    
        const date = new Date(isoString);
        
        // Check for invalid date
        if (isNaN(date.getTime())) return "";
    
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).split("/").join("-");
    };
    
    const handleClick = () => {
        if (btnvalue === 0) {

            setloading(true);
            if (!shopName) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop name  is Required...'
                });
                return;

            }
            if (!ShopAddress) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop Address  is Required...'
                });
                return;

            }
            if (!shopmobile || shopmobile.length !== 10) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: "Shop Mobile Number must be exactly 10 digits.",
                });
                return;
            }
            
            if (!ShopIncharge) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop Incharge Name is Required...'
                });
                return;

            }
            if (!selectedCountry) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Country is Required...'
                });
                return;

            }
            if (!selectedstate) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'State is Required...'
                });
                return;

            }
            if (!selecteddistrict) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'District is Required...'
                });
                return;

            }
            if (!selectedcity) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'city is Required...'
                });
                return;

            }
            if (!selectedarea) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Place is Required...'
                });
                return;

            }
            if (!gender) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Please Select Gender!'
                });
                return;

            }

            const data = {
                login_id:login_id,
                branchcode:BRANCH_CODE,
                shopname: shopName,
                shopaddress: ShopAddress,
                ShopIncharge: ShopIncharge,
                dateofbirth: selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : "",

                gender: gender.value,
                shopmobile: shopmobile,
                shopphone: shopphone,
                shopemail: shopemail,
                shopsize: shopsize,
                shopgst: shopgst,
                shopstatus: active,
                country: selectedCountry.Value,
                state: selectedstate.Value,
                district: selecteddistrict.Value,
                city: selectedcity.Value,
                area: selectedarea.Value,
                pincode: selectedpincode.Value,
                segmentA: isActiveA,
                segmentH: isActiveH,
                segmentT: isActiveT,
                segmentS: isActiveS,
                segmentP: isActiveP,
                segmentW: isActiveW,
                segmentU: isActiveU,
                segmentQ: isActiveQ,
                segmentX: isActiveX,
                nameboardDate: selectednameboardDate ? dayjs(selectednameboardDate).format("YYYY-MM-DD"):"",
                visiteddate:  selectedlastvistedDate?dayjs(selectedlastvistedDate).format("YYYY-MM-DD"):"",
                issuedon:selectedissuedDate? dayjs(selectedissuedDate).format("YYYY-MM-DD"):"",
                validon: selectedvalidDate?dayjs(selectedvalidDate).format("YYYY-MM-DD"):"",
                planneddate: selectedplannedDate,
                completedon: selectedcompletedDate,
            };


            axios.post(BASE_URL + '/subdealercreate', data)
                .then(response => {
                    if (response.status === 200) {
                        setloading(false);
						//fetchSubDealers();
                        Swal.fire({
                            icon: "success",
                            text: response.data.text || 'Data saved successfully!',
                        });
                        clearFields();
                        //window.location.reload();
                    }
                    else if(response.status === 400){
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: 'Unexpected response status. Please try again.'

                        });

                    } 
                    else {
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: 'Unexpected response status. Please try again.'

                        });

                    }
                })
                .catch(error => {
                    setloading(false);
                    if (error.response) {
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: ` ${error.response.data.text}`
                        });


                    } else if (error.request) {
                        setloading(false);
                        console.error('No response received');
                    } else {
                        setloading(false);
                        console.error('Error setting up the request:', error.message);
                    }
                });

        } else {
            setloading(true);
            if (!shopName) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop name  is Required...'
                });
                return;

            }
            if (!ShopAddress) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop Address  is Required...'
                });
                return;

            }
            if (!shopmobile || shopmobile.length !== 10) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: "Shop Mobile Number must be exactly 10 digits.",
                });
                return;
            }
            
            if (!ShopIncharge) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Shop Incharge Name is Required...'
                });
                return;

            }
            if (!selectedCountry) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Country is Required...'
                });
                return;

            }
            if (!selectedstate) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'State is Required...'
                });
                return;

            }
            if (!selecteddistrict) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'District is Required...'
                });
                return;

            }
            if (!selectedcity) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'city is Required...'
                });
                return;

            }
            if (!selectedarea) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Place is Required...'
                });
                return;

            }
            if (!gender) {
                setloading(false);
                Swal.fire({
                    icon: "info",
                    text: 'Please Select Gender!'
                });
                return;

            }
            

            const data = {
                
                login_id:login_id,
                branchcode:BRANCH_CODE,
               subdealercode :selectedSubdealer.Value,
                shopname: shopName,
                shopaddress: ShopAddress,
                ShopIncharge: ShopIncharge,
                dateofbirth:  selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : "",
               gender: gender.value,
                shopmobile: shopmobile,
                shopphone: shopphone,
                shopemail: shopemail,
                shopsize: shopsize,
                shopgst: shopgst,
                shopstatus: active,
                country: selectedCountry.Value,
               state: selectedstate.Value,
               district: selecteddistrict.Value,
                city: selectedcity.Value,
               area: selectedarea.Value,
                pincode: selectedpincode.Value,
                segmentA: isActiveA,
                segmentH: isActiveH,
                segmentT: isActiveT,
                segmentS: isActiveS,
                segmentP: isActiveP,
                segmentW: isActiveW,
                segmentU: isActiveU,
                segmentQ: isActiveQ,
                segmentX: isActiveX,
                nameboardDate: selectednameboardDate ? dayjs(selectednameboardDate).format("YYYY-MM-DD"):"",
                visiteddate:  selectedlastvistedDate?dayjs(selectedlastvistedDate).format("YYYY-MM-DD"):"",
                issuedon:selectedissuedDate? dayjs(selectedissuedDate).format("YYYY-MM-DD"):"",
                validon: selectedvalidDate?dayjs(selectedvalidDate).format("YYYY-MM-DD"):"",
                planneddate: selectedplannedDate,
                completedon: selectedcompletedDate,
            };


            axios.post(BASE_URL + '/subdealerupdate', data)
                .then(response => {
                    if (response.status === 200) {
                        setloading(false);
							//fetchSubDealers();
                        clearFields()
                        Swal.fire({
                            icon: "success",
                            text: response.data.text || 'Data saved successfully!',
                        });

                       


                    } 
                    else if(response.status === 400){
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: response.data.text ||'Retailer Data not updated. Please try again.'

                        });

                    }else {
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: 'Unexpected response status. Please try again.'

                        });

                    }
                })
                .catch(error => {
                    setloading(false);
                    if (error.response) {
                        setloading(false);
                        Swal.fire({
                            icon: "info",
                            text: ` ${error.response.data.text}`
                        });


                    } else if (error.request) {
                        setloading(false);
                        console.error('No response received');
                    } else {
                        setloading(false);
                        console.error('Error setting up the request:', error.message);
                    }
                });
        }
    };
    const clearFields = () => {
        setShopName('');
        setShopAddress("");
        setShopIncharge('');
        setSelectedDate();
        setGender(null);
        setshopmobile("");
        setshopphone("");
        setshopemail("");
        setshopsize("");
        setshopgst("");
        
        setSelectedCountry(null);
        setSelectedstate(null);
        setSelecteddistrict(null);
        setSelectedcity(null);
        setSelectedarea(null);
        setSelectedpincode(null);
        setIsActiveA(false);
        setDisplayTextA('Inactive');
        setDisplayValueA('0');
        setvalueA(0)
        setIsActiveH(false);
        setDisplayTextH('Inactive');
        setDisplayValueH('0');
        setvalueH(0)
        setIsActiveT(false);
        setDisplayTextT('Inactive');
        setDisplayValueT('0');
        setvalueT(0)
        setIsActiveS(false);
        setDisplayTextS('Inactive');
        setDisplayValueS('0');
        setvalueS(0)
        setIsActiveP(false);
        setDisplayTextP('Inactive');
        setDisplayValueP('0');
        setvalueP(0)
        setIsActiveW(false);
        setDisplayTextW('Inactive');
        setDisplayValueW('0');
        setvalueW(0)
        setIsActiveU(false);
        setDisplayTextU('Inactive');
        setDisplayValueU('0');
        setvalueU(0)
        setIsActiveQ(false);
        setDisplayTextQ('Inactive');
        setDisplayValueQ('0');
        setvalueQ(0)
        setIsActiveX(false);
        setDisplayTextX('Inactive');
        setDisplayValueX('0');
        setvalueX(0)
        setselectednameboardDate(null);
        setselectedlastvistedDate(null);
        setselectedissuedDate(null);
        setselectedvalidDate(null);
        setselectedplannedDate('');
        setselectedcompletedDate('');
    };
    

    //handledistrictChange
    return (
        <div>
            <Container>

                <Card style={{
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',

                }}>
                    <div className="mt-5" style={{ justifyContent: 'center' }}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <Autocomplete
                                    options={options}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Choose a Process" variant="outlined" />
                                    )}
                                    value={selectedOption} // Controlled value
                                    onChange={handleProcessChange}
                                    style={{ width: 300 }}
                                />
                            </div>
                            {showquery && (
                                <div className='col-md-4'>

                                    <Autocomplete
                                        options={enquiry_list}
                                        getOptionLabel={(option) => option.label}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Choose a New Enquiry" variant="outlined" />
                                        )}
                                        value={selectedEnquiry} // Controlled value
                                        onChange={handleEnquiryChange}
                                        style={{ width: 300 }}
                                    />


                                </div>
                            )}
                            {showbtn && (''
                                // <div className='col-md-4'>
                                //     <Button
                                //         variant="contained"
                                //         size="small"
                                //         fullWidth
                                //         style={{
                                //             backgroundColor: 'red',
                                //             color: 'white',
                                //             width: 200,
                                //             height: 50,
                                //             fontWeight: 'bold',
                                //         }}
                                //     ><b>Total Counts</b></Button>
                                // </div>
                            )}
                            {showexisting && (
                                <>
                                    <div className='col-md-4'>

                                        <Autocomplete
                                            options={subdealer_list}
                                            getOptionLabel={(option) => `${option.Value} - ${option.Label}`}
                                            value={selectedSubdealer}
                                            onChange={handleSubdealerChange}


                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select SubDealers"
                                                    variant="outlined"
                                                    required
                                                    style={{ width: 300 }}
                                                />
                                            )}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <br />
                </Card>
            </Container>


            <Container>

                <div>
                    <Tabs value={tabValue} onChange={handleChange} aria-label="Tabs example">
                        <Tab label="Personal Details" value="Personal Details" />
                        <Tab label="Area Details" value="Area Details" />
                        <Tab label="Segment Configuration" value="Segment Configuration" />
                        <Tab label="General Details" value="General Details" />
                    </Tabs>

                    {tabValue === 'Personal Details' && (
                        <div>
                            <Card style={{
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                borderRadius: '10px',
                            }}>

                                <br />
                                <Box>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label>Nature<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete

                                                options={Retailer}
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="" variant="outlined" />
                                                )}
                                                //value={selectedRetailer} 
                                                defaultValue={defaultValue} // Set the 
                                                value={defaultValue}
                                                onChange={handleRetailerChange}
                                                style={{ width: 300 }}
                                            />

                                        </div>

                                        <div className='col-md-4'>
                                            <label >Retailer Shop Name<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <TextField
                                                fullWidth
                                                id="shopname"
                                                label=""
                                                variant="outlined"
                                                value={shopName}
                                                onChange={handleShopNameChange}
                                            />


                                        </div>

                                        <div className='col-md-4'>
                                            <label >Shop Address<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <TextField
                                                fullWidth
                                                id="shopname"
                                                label=""
                                                variant="outlined"
                                                value={ShopAddress}
                                                onChange={handleShopAddressChange}
                                            />


                                        </div>

                                    </div>


                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label >Name Of Incharge<span style={{ color: 'red' }}> *</span></label>

                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={ShopIncharge}
                                                onChange={handleShopInchargeChange}
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={[
                                                        'DatePicker',
                                                        'MobileDatePicker',
                                                        'DesktopDatePicker',
                                                        'StaticDatePicker',
                                                    ]}
                                                >

                                                    <Stack spacing={2} sx={{}}>
                                                        <label >Date of Birth</label>
                                                        <div>

                                                            <DemoItem>
                                                                <MobileDatePicker
                                                                    value={selectedDate}
                                                                    onChange={handleDateChange}
                                                                    format="DD-MM-YYYY" 
                                                                    fullWidth
                                                                />
                                                            </DemoItem>
                                                        </div>
                                                    </Stack>
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </div>
                                        <div className='col-md-4'>

                                            <label>Gender </label>
                                            <br />  <br />




                                            <Autocomplete
                                                options={genderOptions}
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="" variant="outlined" />
                                                )}
                                                value={gender}
                                                onChange={handleGenderChange}
                                                style={{ width: 300 }}
                                            />


                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label >Mobile NO .<span style={{ color: 'red' }}> *</span></label>
                                            <br />
                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={shopmobile}
                                                onChange={handleshopmobileChange}
                                            />
                                        </div>

                                        <div className='col-md-4'>
                                            <label >Phone NO .</label>
                                            <br />
                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={shopphone || ''}
                                                onChange={handleshopphoneChange}
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <label >Email </label>
                                            <br />
                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={shopemail}
                                                onChange={handleshopemailChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label > Size of Shop(sq feet) </label>
                                            <br />
                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={shopsize}
                                                onChange={handleshopsizeChange}
                                            />
                                        </div>

                                        <div className='col-md-4'>
                                            <label >GST NO.</label>
                                            <br />
                                            <TextField
                                                label=""
                                                fullWidth
                                                margin="normal"
                                                value={shopgst}
                                                onChange={handleshopgstChange}
                                            />
                                        </div>
                                        <div className='col-md-4'>

                                            <label>Status</label>
                                            <br />


                                            <RadioGroup
                                                row
                                                name="active"
                                                value={active} // Bind value to the state variable
                                                onChange={handleActiveChange} // Handle onChange event with the defined function
                                            >
                                                <FormControlLabel value="1" control={<Radio />} label="Active" />
                                                <FormControlLabel value="0" control={<Radio />} label="In Active" />
                                            </RadioGroup>

                                        </div>
                                    </div>


                                </Box>


                            </Card>
                        </div>
                    )}
                    {tabValue === 'Area Details' && (
                        <div>
                            <Card style={{
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                borderRadius: '10px',
                            }}>


                                <Box>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label>Country<span style={{ color: 'red' }}> *</span></label>
                                            <br />



                                            <Autocomplete
                                                options={county_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selectedCountry}
                                                //onChange={(event, newValue) => setSelectedCountry(newValue)}
                                                onChange={handleCountryChange}
                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Country"
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />




                                        </div>

                                        <div className='col-md-4'>
                                            <label>State<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete
                                                options={state_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selectedstate}
                                               // onChange={handlestateChange}
                                                onChange={(event, newValue) => setSelectedstate(newValue)}
                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />



                                        </div>

                                        <div className='col-md-4'>
                                            <label>District<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete
                                                options={district_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selecteddistrict}
                                                //onChange={handledistrictChange}
                                                onChange={(event, newValue) => setSelecteddistrict(newValue)}
                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />

                                        </div>


                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label>City<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete
                                                options={city_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selectedcity}
                                               // onChange={handlecityChange}
                                                onChange={(event, newValue) => setSelectedcity(newValue)}
                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />

                                        </div>

                                        <div className='col-md-4'>
                                            <label>Place<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete
                                                options={area_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selectedarea}
                                               // onChange={handleareaChange}
                                                onChange={(event, newValue) => setSelectedarea(newValue)}
                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />

                                        </div>

                                        <div className='col-md-4'>
                                            <label>Pin Code<span style={{ color: 'red' }}> *</span></label>
                                            <br />

                                            <Autocomplete
                                                options={pincode_list}
                                                getOptionLabel={(option) => option.Label}
                                                value={selectedpincode}
                                                onChange={handlepincodeChange}

                                                style={{ marginTop: "15px" }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        required
                                                        style={{ width: 300 }}
                                                    />
                                                )}
                                            />

                                        </div>


                                    </div>




                                    <br />



                                </Box>


                            </Card>
                        </div>
                    )}
                    {tabValue === 'Segment Configuration' && (
                        <div>
                            <div className='row'>
                                <div className='col-md-2'>
                                    <h5>Segment A : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveA ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleA}
                                    >
                                        {displayTextA}
                                    </button>

                                </div>
                                <div className='col-md-2'>
                                    <h5>Segment H : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveH ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleH}
                                    >
                                        {displayTextH}
                                    </button>

                                </div>
                            </div>
                            <br />
                            <div className='row'>
                                <div className='col-md-2'>
                                    <h5>Segment T : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveT ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleT}
                                    >
                                        {displayTextT}
                                    </button>

                                </div>
                                <div className='col-md-2'>
                                    <h5>Segment S : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveS ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleS}
                                    >
                                        {displayTextS}
                                    </button>

                                </div>
                            </div>
                            <br />
                            <div className='row'>
                                <div className='col-md-2'>
                                    <h5>Segment P : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveP ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleP}
                                    >
                                        {displayTextP}
                                    </button>

                                </div>
                                <div className='col-md-2'>
                                    <h5>Segment W : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveW ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleW}
                                    >
                                        {displayTextW}
                                    </button>

                                </div>
                            </div>
                            <br />
                            <div className='row'>
                                <div className='col-md-2'>
                                    <h5>Segment U : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveU ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleU}
                                    >
                                        {displayTextU}
                                    </button>

                                </div>
                                <div className='col-md-2'>
                                    <h5>Segment Q : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveQ ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleQ}
                                    >
                                        {displayTextQ}
                                    </button>

                                </div>
                            </div>
                            <br />
                            <div className='row'>
                                <div className='col-md-2'>
                                    <h5>Segment X : </h5>
                                </div>
                                <div className='col-md-2'>
                                    <button
                                        className={`btn ${isActiveX ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={handleToggleX}
                                    >
                                        {displayTextX}
                                    </button>


                                </div>

                            </div>
                            <br />
                            {/* <div className='row'>
                                    <div >
                                        <Button size="small" fullWidth variant="contained" ><b>Click To Create</b></Button>
                                    </div>

                                </div> */}
                        </div>
                    )}
                    {tabValue === 'General Details' && (
                        <div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={[
                                                'DatePicker',
                                                'MobileDatePicker',
                                                'DesktopDatePicker',
                                                'StaticDatePicker',
                                            ]}
                                        >

                                            <Stack spacing={2} sx={{}}>
                                                <label >Name Board Provided On</label>
                                                <div>

                                                    <DemoItem>
                                                        <MobileDatePicker
                                                            value={selectednameboardDate}
                                                            onChange={handlenameboardDateChange}
                                                            format="DD-MM-YYYY"
                                                            fullWidth
                                                        />
                                                    </DemoItem>
                                                </div>
                                            </Stack>
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                                <div className='col-md-4'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={[
                                                'DatePicker',
                                                'MobileDatePicker',
                                                'DesktopDatePicker',
                                                'StaticDatePicker',
                                            ]}
                                        >

                                            <Stack spacing={2} sx={{}}>
                                                <label >Executive Last Visited</label>
                                                <div>

                                                    <DemoItem>
                                                        <MobileDatePicker
                                                            value={selectedlastvistedDate}
                                                            onChange={handlelastvistedChange}
                                                            format="DD-MM-YYYY"
                                                            fullWidth
                                                        />
                                                    </DemoItem>
                                                </div>
                                            </Stack>
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <h4>Sub-Dealership Certificate</h4>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={[
                                                'DatePicker',
                                                'MobileDatePicker',
                                                'DesktopDatePicker',
                                                'StaticDatePicker',
                                            ]}
                                        >

                                            <Stack spacing={2} sx={{}}>
                                                <label >Issued On</label>
                                                <div>

                                                    <DemoItem>
                                                        <MobileDatePicker
                                                            value={selectedissuedDate}
                                                            format="DD-MM-YYYY"
                                                            onChange={handleissuedDateChange}
                                                            fullWidth
                                                        />
                                                    </DemoItem>
                                                </div>
                                            </Stack>
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                                <div className='col-md-4'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={[
                                                'DatePicker',
                                                'MobileDatePicker',
                                                'DesktopDatePicker',
                                                'StaticDatePicker',
                                            ]}
                                        >

                                            <Stack spacing={2} sx={{}}>
                                                <label >Validate Upto</label>
                                                <div>

                                                    <DemoItem>
                                                        <MobileDatePicker
                                                            value={selectedvalidDate}
                                                            onChange={handlevalidDateChange}
                                                            fullWidth
                                                             format="DD-MM-YYYY"
                                                        />
                                                    </DemoItem>
                                                </div>
                                            </Stack>
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <h4>Supporting Activities</h4>
                            <div className='row'>
                                <div className='col-md-4'>
                                    

                                            <Stack spacing={2} sx={{}}>
                                                <label >Planned</label>
                                                <div>

                                                <TextField  
    value={selectedplannedDate}
    onChange={(e) => handleplannedDateChange(e.target.value)}
    fullWidth
 
/>

                                                   
                                                </div>
                                            </Stack>
                                       
                                </div>
                                <div className='col-md-4'>
                                    

                                            <Stack spacing={2} sx={{}}>
                                                <label >Completed/Provided</label>
                                                <div>

                                                <TextField  
    value={selectedcompletedDate}
    onChange={(e) => handlecompletedDateChange(e.target.value)}
    fullWidth
 

/>
                                                       
                                                 
                                                </div>
                                            </Stack>
                                   
                                </div>
                            </div>

                          

                        </div>
                    )}
                </div>

                <div className='row'>

                    <div>
                        {btnvalue === 0 ? (
                            <Button size="small" fullWidth variant="contained" onClick={handleClick} ><b>Click To Create</b></Button>
                        ) : (
                            <Button size="small" fullWidth variant="contained" onClick={handleClick} ><b>Click To Update</b></Button>
                        )}
                    </div>


                </div>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
            </Container>

        </div>
    
);

}

export default Subdealercreate;